var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Dialog from '../../Dialog';
var Footer = styled(Dialog.Footer)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  flex-direction: column;\n  width: 100%;\n"])), function (_ref) {
  var spacing = _ref.theme.yoga.spacing;
  return "\n  margin-left: " + spacing.zero + ";\n  gap: " + spacing.small + "px;\n  ";
});
Footer.displayName = 'BottomSheet.Footer';
export default Footer;